import { createContext, useState, useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { LocaleContextType } from '@/types';

export const LocaleContext = createContext<LocaleContextType | null>(null);

interface LocaleProviderProps {
  children: ReactNode;
}

export const LocaleProvider = ({ children }: LocaleProviderProps): JSX.Element => {
  const { i18n } = useTranslation();
  const [language, setLanguageState] = useState<string>(i18n.language || 'en');

  const setLanguage = (lang: string): void => {
    i18n.changeLanguage(lang);
    setLanguageState(lang);
    localStorage.setItem('dim-language', lang);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem('dim-language');
    if (savedLang && savedLang !== language) {
      i18n.changeLanguage(savedLang);
      setLanguageState(savedLang);
    }
  }, [i18n, language]);

  useEffect(() => {
    const langMap: Record<string, string> = {
      'nb-NO': 'nb',
      'nn-NO': 'nn',
      en: 'en',
    };

    const htmlLang = langMap[language] || language.split('-')[0] || 'en';
    document.documentElement.lang = htmlLang;
  }, [language]);

  return (
    <LocaleContext.Provider value={{ language, setLanguage }}>{children}</LocaleContext.Provider>
  );
};
